// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z-wP","col":"styles_col__2fe3j","actions":"styles_actions__1iGli","conflict":"styles_conflict__1jnLy"};